import { Box, HStack, Span, Text } from '@chakra-ui/react';
import { memo, type ReactNode } from 'react';
import { MessageExpire } from '../MessageBubble';
import { useItemExpireContext } from '../ItemWithExpireAnimate/context';

export interface MessageHeaderProps {
  userName: ReactNode;
  createdAtDisplay: string | undefined;
  isMe?: boolean;
  onMentionClick?: () => void;
}

function MessageHeader({
  createdAtDisplay,
  userName,
  isMe = false,
  onMentionClick,
}: MessageHeaderProps) {
  const { displayTime } = useItemExpireContext();
  return (
    <Box className="MessageHeader" display="inline-flex" gap="2" alignItems="center" pb="0.5">
      {!isMe && (
        <HStack
          className="MessageHeader_name"
          fontSize="xs"
          fontWeight="semibold"
          pos="relative"
          gap="1"
          _hover={
            onMentionClick
              ? {
                  color: 'colorPalette.solid',
                  '& .MessageHeader_mention': {
                    display: 'inline',
                  },
                }
              : undefined
          }
          cursor={onMentionClick ? 'pointer' : 'default'}
          onClick={onMentionClick}
        >
          {onMentionClick && (
            <Span
              className="MessageHeader_mention"
              display="none"
              _groupHover={{ display: 'inline' }}
              pos="absolute"
              left="-0.9em"
              top="0"
            >
              @
            </Span>
          )}
          {userName}
        </HStack>
      )}
      <Text className="MessageHeader_time" fontSize="xs" color="fg.subtle" display="none">
        {createdAtDisplay} {displayTime && <Span ml="2">|</Span>}
      </Text>
      <MessageExpire />
    </Box>
  );
}

const MemoizedMessageHeader = memo(MessageHeader);
export { MemoizedMessageHeader as MessageHeader };
